
import { militaryMessages } from './en-US';

export const programId = '5dae4c757ecb6220f26d41f3';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: true,
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': militaryMessages,
    },
};
